import { render, staticRenderFns } from "./forgotpsw.vue?vue&type=template&id=4ea915e1"
import script from "./forgotpsw.vue?vue&type=script&lang=js"
export * from "./forgotpsw.vue?vue&type=script&lang=js"
import style0 from "./forgotpsw.vue?vue&type=style&index=0&id=4ea915e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports